import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectLink from 'components/molecules/projectLink';

import Loader from 'components/atoms/svgLoader';

import { loaderIn, loaderOut, fadeIn } from 'components/utils/animation';
import './style.css';

class ProjectGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animated: false
        };
    }

    componentDidMount() {
        if (this.props.hasLoaded) {
            this.loaderNode.style.display = 'none';
            fadeIn(this.gridNode, 'flex');
            this.setState({
                animated: true
            });
        } else {
            loaderIn(this.loaderNode);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.hasLoaded &&
            !this.props.isLoading &&
            !this.state.animated
        ) {
            loaderOut(this.loaderNode).finished.then(() => {
                fadeIn(this.gridNode, 'flex');
            });

            this.setState({
                animated: true
            });
        }
    }

    render() {
        let { projects } = this.props;
        return (
            <nav className="ProjectGrid">
                <div
                    className="ProjectGrid__loader"
                    ref={div => {
                        this.loaderNode = div;
                    }}
                >
                    <Loader />
                </div>
                <div
                    className="ProjectGrid__grid"
                    ref={div => {
                        this.gridNode = div;
                    }}
                >
                    {projects.map((item, i) => (
                        <div key={i} className="ProjectGrid__grid__item">
                            <ProjectLink
                                slug={item.fields.slug}
                                title={item.fields.title}
                                client={item.fields.client.fields.title}
                                imageUrl={
                                    item.fields.previewImage.fields.file.url
                                }
                                imageAlt={item.fields.previewImage.fields.title}
                            />
                        </div>
                    ))}
                </div>
            </nav>
        );
    }
}

ProjectGrid.propTypes = {
    projects: PropTypes.array,
    isLoading: PropTypes.bool,
    hasError: PropTypes.bool
};

ProjectGrid.defaultProps = {
    projects: [],
    isLoading: true,
    hasError: false
};

export default ProjectGrid;



// WEBPACK FOOTER //
// ./src/components/organisms/projectGrid/index.js